import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContentService {

  constructor(private http: HttpClient) { }

  getTaxonomies(): Observable<any> {
    const url = `${environment.apiOrigin}/api/content/taxonomies`;
    return this.http.get(url);
  }

  getTaxonomy(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/content/taxonomies/${id}`;
    return this.http.get(url);
  }

  saveTaxonomy(taxonomy: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/content/taxonomies`;
    if (taxonomy.id) {
      return this.http.post(url, taxonomy);
    } else {
      return this.http.put(url, taxonomy);
    }
  }

  getForms(): Observable<any> {
    const url = `${environment.apiOrigin}/api/content/forms`;
    return this.http.get(url);
  }

  deleteForm(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/content/forms/${id}`;
    return this.http.delete(url);
  }

  getForm(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/content/forms/${id}`;
    return this.http.get(url);
  }

  saveForm(form: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/content/forms`;
    if (form.id) {
      return this.http.post(url, form);
    } else {
      return this.http.put(url, form);
    }
  }

  getFormByFormName(formName: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/content/form-by-name`;
    const criteria: any = {};
    criteria.formName = formName;
    return this.http.post(url, criteria);
  }

  getTaxonomyByName(taxonomyName: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/content/taxonomies/by-name`;
    const criteria: any = {};
    criteria.name = taxonomyName;
    return this.http.post(url, criteria);
  }
}
